import { useState, useEffect } from "react";
import { useIntl } from "react-intl";

import GoAiguaTextInput from "components/generic/goaiguatextinput";
import ModalContentLayout from "components/generic/modal-content-layout.component";

import { updateGisHierarchyItem } from "services/requests/v1/gishierarchyitem";

import { HierarchyItemType } from "types/generic";
import { useGisLayersTreeContext } from "storage/context/gis-layers-tree-hierarchy-context";
import { getFirstHierarchyGroupOnList } from "utils/components/gis-tree-hierarchy-functions";

type EditNameGisHierarchyType = {
    closeModalFn: () => void;
    loadHierarchiesById: () => Promise<void>;
    gisHierarchySelected: HierarchyItemType[];
    setGisHierarchySelected: (
        gisHierarchySelected: HierarchyItemType[]
    ) => void;
};

const EditNameGisHierarchy = ({
    closeModalFn,
    gisHierarchySelected,
    loadHierarchiesById,
    setGisHierarchySelected,
}: EditNameGisHierarchyType) => {
    const intl = useIntl();
    const [newName, setNewName] = useState<string>("");

    const { subscribeContent, unsubscribeContent, contentName, setError } =
        useGisLayersTreeContext();

    const originalName = getFirstHierarchyGroupOnList(gisHierarchySelected)
        ? getFirstHierarchyGroupOnList(gisHierarchySelected)!.name
        : "";

    const handleSaveClick = async () => {
        subscribeContent(contentName);

        try {
            let newGroup = {
                ...getFirstHierarchyGroupOnList(gisHierarchySelected),
            };
            newGroup.name = newName;
            await updateGisHierarchyItem(newGroup as HierarchyItemType);
            await loadHierarchiesById();
            setGisHierarchySelected([]);
            unsubscribeContent(contentName, true);
            closeModalFn();
        } catch (error) {
            setError(contentName);
        }
    };

    const defineSaveButtonStatus = () => {
        if (newName !== originalName) return "enabled";
        return "disabled";
    };

    useEffect(() => {
        setNewName(originalName);
    }, []);

    return (
        <ModalContentLayout
            firstButtonTitle={intl.formatMessage({ id: "app.gis.cancel" })}
            onFirstButtonClick={closeModalFn}
            firstButtonStatus="enabled"
            secondButtonTitle={intl.formatMessage({ id: "app.users.save" })}
            onSecondButtonClick={handleSaveClick}
            secondButtonStatus={defineSaveButtonStatus()}
        >
            <div className="c-edit-name-gis-hierarchy__container">
                <div className="c-edit-name-gis-hierarchy__container__title">
                    {intl.formatMessage({
                        id: "app.hierarchy.modify_the_group_name",
                    })}
                </div>
                <GoAiguaTextInput
                    text={newName}
                    onChange={(value) => setNewName(value)}
                    className="c-edit-name-gis-hierarchy__container__input"
                />
            </div>
        </ModalContentLayout>
    );
};

export default EditNameGisHierarchy;
